import { ReactNode } from 'react';

import {
  Box,
  type BoxProps,
  IconButton,
  Typography,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import { RiExpandDiagonalSLine } from '@remixicon/react';
import classNames from 'classnames';

const styles = createStyles({
  root: {
    position: 'relative',
    flexDirection: 'column',
    gap: 'var(--encore-spacing-tighter-4)',
  },
  header: {
    alignItems: 'center',
    gap: 'var(--encore-spacing-tighter-2)',
  },
  title: {
    flex: 1,
    minWidth: 0,
  },
  expandButton: {
    flexShrink: 0,
    alignSelf: 'start',
    marginRight: '-6px', // Alignment adjustment
  },
});

export interface ActivityItemPanelProps
  extends Omit<BoxProps, 'title'>,
    WithStyles<typeof styles> {
  title?: ReactNode;
  onExpand?: () => void;
}

const ActivityItemPanel = ({
  classes,
  className,
  children,
  onExpand,
  title,
  ...props
}: ActivityItemPanelProps) => {
  return (
    <Box
      display="flex"
      className={classNames(classes.root, className)}
      {...props}
    >
      {(title || onExpand) && (
        <Box display="flex" className={classes.header}>
          {title && (
            <Typography
              variant="body2"
              style={{ fontWeight: 'bold' }}
              className={classes.title}
            >
              {title}
            </Typography>
          )}
          {onExpand && (
            <IconButton
              size="small"
              onClick={onExpand}
              className={classes.expandButton}
              aria-label="Expand"
            >
              <RiExpandDiagonalSLine />
            </IconButton>
          )}
        </Box>
      )}
      {children}
    </Box>
  );
};

export default withStyles(styles)(ActivityItemPanel);
